module.exports = __webpack_public_path__ + "img/US.f2039a4f.webp";